module.exports = __webpack_public_path__ + "img/sit-logo.007088a1.gif";